import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { OiqLayoutNavItemComponent } from './nav-item.component';
import { OiqLayoutNavItemModel } from './nav-item.models';
import { OiqLayoutNavPath } from './nav.models';

@Component({
  selector: 'oiq-layout-nav',
  imports: [CommonModule, MatIconModule, OiqLayoutNavItemComponent],
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OiqLayoutNavComponent {
  @HostBinding('class.sideBarExpanded') get sidebarExpanded(): boolean {
    return this.isSidebarExpanded;
  }

  @Input() isSidebarExpanded: boolean = false;
  @Input() path: OiqLayoutNavPath | null = null;

  private _menu: OiqLayoutNavItemModel[] = [];
  @Input()
  set menu(m: OiqLayoutNavItemModel[]) {
    this._menu = m;
    this.visibleItems = (this._menu || []).filter(_item => _item.visible !== false);
  }
  get menu(): OiqLayoutNavItemModel[] {
    return this._menu;
  }

  public visibleItems: OiqLayoutNavItemModel[] = [];

  trackByItem(index: number, item: any): any {
    return JSON.stringify(item);
  }
}
